import { CxsBasket, CxsBasketLine } from '../model';
import { markProductUpdate, updateEntry } from '../utils';
import { setGiftOptions } from '@accelerator/basket/action-handlers/set-gift-options';
import isEqual from 'lodash.isequal';

const createNewLine = (properties: Partial<CxsBasketLine> = {}): CxsBasketLine => ({
    variantNo: '',
    quantity: 0,
    stockQuantity: 0,
    unitPrice: '',
    unitPriceExcludingVat: '',
    priceAmount: '',
    priceAmountExcludingVat: '',
    unitPriceRaw: 0,
    unitPriceExcludingVatRaw: 0,
    priceAmountRaw: 0,
    priceAmountExcludingVatRaw: 0,
    productUrl: '',
    imageUrl: '',
    onSale: false,
    points: 0,
    inStock: true,
    productName: '',
    vatAmount: '',
    discountAmount: '',
    vatAmountRaw: 0,
    discountAmountRaw: 0,
    discountPercentage: 0,
    giftWrappingPrice: '',
    giftWrappingPriceExcludingVat: '',
    lineType: 'Normal',
    isGiftCard: false,
    giftWrappingPriceRaw: 0,
    giftWrappingPriceExcludingVatRaw: 0,
    giftWrappings: [],
    priceAmountBeforeDiscount: '',
    priceAmountBeforeDiscountRaw: 0,
    quantityThatIsFree: 0,
    quantityUsedOnCampaign: 0,
    digitalProduct: false,
    pallelevering: false,
    giftWrappingsCardPrice: '',
    giftWrappingsCardPriceExcludingVat: '',
    giftWrappingsCardPriceRaw: 0,
    giftWrappingsCardPriceExcludingVatRaw: 0,
    ...properties
});

export const addToBasket = (
    basket: CxsBasket,
    productId: string,
    quantityToAdd: number,
    asFreeProduct: boolean = false,
    giftWrappingId?: string,
    giftCardId?: string,
    giftCardText?: string
): CxsBasket => {
    const currentProductIndex = basket.lines.findIndex(line => line.variantNo === productId);
    let lines: CxsBasket['lines'];
    if (currentProductIndex !== -1) {
        const currentLine = basket.lines[currentProductIndex];
        const newQuantity = currentLine.quantity + quantityToAdd;
        const { quantityThatIsFree } = currentLine;

        const updatedGiftCardOptionsLine = setGiftOptions(currentLine, giftWrappingId, giftCardId, giftCardText);
        // NOTE: KOP-1957 | validate if we are adding the exact same gift options (giftWrappingId, giftCardId and giftCardText)
        const isSameContent = isEqual(currentLine, updatedGiftCardOptionsLine);

        // in case false, that means we are adding the same product but with different gift options, which means
        // we should create a new line, this need to be handled by BE
        if (!isSameContent) {
            lines = updateEntry(
                basket.lines,
                createNewLine({
                    ...updatedGiftCardOptionsLine,
                    variantNo: productId,
                    quantity: quantityToAdd
                }),
                basket.lines.length
            );
        }
        // in case true, that means we are adding the same product with, without gift options or the exact same wrappingId, cardId and card text, which means
        // we should update the current line
        else {
            lines = updateEntry(
                basket.lines,
                {
                    ...updatedGiftCardOptionsLine,
                    quantity: newQuantity,
                    quantityThatIsFree: asFreeProduct ? quantityThatIsFree + quantityToAdd : quantityThatIsFree
                },
                currentProductIndex
            );
        }

        currentLine.relatedFreeProducts?.forEach(relatedFreeProductId => {
            lines = addToBasket({ ...basket, lines }, relatedFreeProductId, quantityToAdd, true).lines;
        });
    } else {
        lines = updateEntry(
            basket.lines,
            createNewLine({
                ...setGiftOptions(basket.lines[currentProductIndex], giftWrappingId, giftCardId, giftCardText),
                variantNo: productId,
                quantity: quantityToAdd
            }),
            basket.lines.length
        );
    }
    return {
        ...basket,
        lines,
        ...markProductUpdate(basket, productId)
    };
};
